@use "sass:math";
@use "~theme/typography";
@use "~theme/breakpoints";

$choices-width: 440px;

.container {
  flex-grow: 1; // ensures component stretches to fill the screen vertically
  width: 100%;

  @include breakpoints.desktop {
    flex: 1;
  }
}

.layout {
  padding: 24px var(--mobile-gutter);

  @include breakpoints.desktop {
    border-bottom: 1px solid var(--gray-06);
    height: 478px;
  }
}

.divider {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 0px;
    border: none;
    border-bottom: 4px solid var(--blue-01);
    width: 35em;
  }
}

.prompt {
  margin-bottom: 10px;
  @include breakpoints.desktop {
    max-width: 100%;
    margin-bottom: 40px;
  }
}

.headline {
  @include typography.heading3;
  letter-spacing: 0.10rem;
  margin: 0;
}

.choices {
  padding: 0;

  @include breakpoints.desktop {    
    width: 40%;
    grid-area: choices;
    padding: 0 40px;
    margin: 0;
  }
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/woman.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;

    // stretch the diagonal area so it has the right height.
    height: math.div(100%, math.sin(90deg - $rotate-amount));
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.button {
  @include typography.heading4;
  border: 4px solid var(--white);
  border-radius: 8px;
  cursor: pointer;
  filter: drop-shadow(0 2px 4px var(--gray-01));
  padding: 28px 16px;
  background-color: var(--white);
  margin: 8px 0;
  align-items: center;
  outline: none;
  width: 100%;
  text-align: center;

  &:hover {
    border-color: var(--highlight-blue);
  }

  &:active {
    // filter: drop-shadow(0 2px 4px var(--highlight-blue));
    // border-color: var(--white);
    border-color: var(--highlight-blue);
  }

    // &:focus {
    //   filter: drop-shadow(0 2px 4px var(--highlight-blue));
    // }
}

.selected {
  border: 4px solid var(--highlight-blue);
  @include breakpoints.desktop {
    background: var(--blue-03);
    border: 4px solid var(--highlight-blue);
  }
}

.requiredMessage {
  color: red;
  padding-top: 5px;
  margin: 5px 0px;
  font-size: 12px;
  font-weight: 600;
  @include breakpoints.desktop {
    font-size: 16px;
  }
}